export function createIdRandom () {
  return {
    id: generateId()
  }
}

function generateId () {
  return Math.random().toString(36).substring(2, 15)
}
